<!--生产制造-生产准备-请假录入-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <template #desOrganizationCodeTitle>
          <span><i class="toRequired">*</i>组织</span>
        </template>
        <global-select
          v-decorator="['desOrganizationCode']"
          :allow-clear="false"
          :default-active-first-option="true"
          slot="desOrganizationCode"
          :value.sync="queryParams.desOrganizationCode"
          selectType="select"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <global-select
          ref="employeeCodeRef"
          slot="employeeCode"
          :value.sync="queryParams.employeeCode"
          selectType="selectAssembleSearch"
          requestApi="/bom/employee/list"
          :selectItem="{ value: 'employeeCode', label: 'employeeName' }"
          searchParam="employeeCode"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" v-hasPermi="['bom:bomEmployeeLeaveCc:add']" @click="handleAdd">新建</a-button>
        <a-button :loading="loading" @click="handleDel" v-hasPermi="['bom:bomEmployeeLeaveCc:del']" type="danger" :disabled="selectedRows.length < 1">删除</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:bomEmployeeLeaveCc:export']" @click="handleExport">导出</a-button>
        <download-modal :apiFun="apiEmployeeLeaveCcExport" ref="download" />
        <addRoleModal ref="addRoleModalRef" @refreshFun="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :columns="columns"
          @selectedRowChange="selectedRowChange"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }">
          <!-- 请假日期 -->
          <template slot="leaveTime" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
            <a-date-picker v-else style="width: 100%" :allowClear="false" v-model="record.leaveTime" valueFormat="YYYY-MM-DD 00:00:00" />
          </template>
          <!-- 请假小时数 -->
          <template slot="leaveHour" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input-number
              v-else
              :allowClear="false"
              style="width: 100%"
              v-model="record.leaveHour"
              :min="0"
              :max="24"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
            />
          </template>
          <!-- 备注 -->
          <template slot="remark" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.remark" placeholder="请输入" :maxLength="100" />
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" v-hasPermi="['bom:bomEmployeeLeaveCc:edit']" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import addRoleModal from './components/addRoleModal'
import { mapState } from 'vuex'
import {
  apiEmployeeLeaveCcDel,
  apiEmployeeLeaveCcExport,
  apiEmployeeLeaveCcSaveOrUpdate,
  listEmployeeLeaveCcList
} from '@/api/mes/productionPrepare/leaveEntry'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'LeaveEntry',
  components: { addRoleModal, DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      loading: false,
      apiEmployeeLeaveCcExport,
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(listEmployeeLeaveCcList, false),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 查询参数
      queryParams: {
        desOrganizationCode: undefined,
        employeeCode: undefined,
        leaveTime: undefined,
        leaveTimeStart: undefined,
        leaveTimeEnd: undefined
      },
      formList: [
        { label: '组织', decorator: ['desOrganizationCode'], type: 'desOrganizationCode', labelSlot: 'desOrganizationCodeTitle' },
        { label: '人员编码', decorator: ['employeeCode'], type: 'employeeCode' },
        {
          label: '日期',
          type: 'range',
          decorator: ['leaveTime'],
          disposeFormat: {
            leaveTimeStart: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            leaveTimeEnd: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        }
      ],
      // 表格字段
      columns: [
        { title: '组织', dataIndex: 'organizationName', align: 'center' },
        { title: '人员编码', dataIndex: 'employeeCode', align: 'center' },
        { title: '姓名', dataIndex: 'employeeName', align: 'center' },
        { title: '请假日期', dataIndex: 'leaveTime', scopedSlots: { customRender: 'leaveTime' }, align: 'center' },
        { title: '请假小时数(h)', dataIndex: 'leaveHour', scopedSlots: { customRender: 'leaveHour' }, align: 'center' },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, width: 200, align: 'center' },
        { title: '创建人', dataIndex: 'createName', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', align: 'center' },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  mounted() {
    if(this.organizationCodeOrigin) {
      // 初始化拿左上角组织
      this.queryParams.desOrganizationCode = this.organizationCodeOrigin
      this.$refs.refSearchForm.form.setFieldsValue({ desOrganizationCode: this.queryParams.desOrganizationCode })
    }
    this.onSearch()
  },
  methods: {
    // 删除操作
    handleDel() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.$confirm({
        title: '警告',
        content: `确认要删除已选择数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          const ids = this.selectedRows?.map(obj => obj.id)
          this.loading = true;
          apiEmployeeLeaveCcDel(ids).then(res => {
            if (res?.code === 200) {
              this.$message.success('删除成功!')
              this.handleOk(false)
            } else {
              this.$message.error(res?.msg || '删除失败')
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 保存
    handleSave(record) {
      this.loading = true;
      apiEmployeeLeaveCcSaveOrUpdate(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('编辑成功')
          this.handleOk(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增
    handleAdd() {
      this.$refs.addRoleModalRef.show()
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      params.desOrganizationCode = this.queryParams.desOrganizationCode
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        desOrganizationCode: this.queryParams.desOrganizationCode,
        employeeCode: undefined,
        leaveTime: undefined,
        leaveTimeStart: undefined,
        leaveTimeEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less"></style>
